export default __webpack_public_path__ + "static/media/Edit.6973171d.svg";